import { defaultAppConfig } from './default-app-config';

type AppEnvironment = 'stage' | 'dev';

interface IAppConstants {
  APP_ENVIRONMENT: AppEnvironment;
}

export const AppConstants: IAppConstants = {
  APP_ENVIRONMENT: 'stage',
};

export enum FeatureAppNames {
  FORMS = 'forms',
  DEFAULT = 'default',
}

export const appsUMD = {
  [FeatureAppNames.FORMS]: '/assets/forms/forms-umd.js',
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appsUMD,
};

export const appsCommonsJS = {
  [FeatureAppNames.FORMS]: '/assets/forms/forms-commonjs.js',
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appsCommonsJS,
};
